import { purchaseOrderStatusName } from '../constants/purchase-order-status.js';
export function canIssuePurchaseOrder(statusName) {
    return statusName === purchaseOrderStatusName.DRAFT;
}
//# sourceMappingURL=can-issue-purchase-order.js.map